var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","flex-direction":"column","margin":"20px"}},[_c('v-data-table',{staticClass:"custom-data-table",staticStyle:{"width":"100%"},attrs:{"headers":_vm.headers,"items":_vm.items,"footer-props":{
                'items-per-page-options': [20, 50, 100, -1],
                'items-per-page-text': this.$t('_lignes_par_page_'),           
              }}}),_c('v-btn',{staticStyle:{"width":"300px"}},[_vm._v(_vm._s(_vm.$t("_telecharger_le_tableau_comparatif_")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }